import type { GuestQuoteView } from '@repo/api-contracts';
import type { ReactElement } from 'react';
import { GuestQuoteLinkNotice, quoteImageAlt } from '@/entities/quote';
import { DesignThumbnail, EyebrowLabel } from '@/shared/ui';
import { GuestQuoteSummary } from './guest-quote-summary';
import { GuestQuoteSupport } from './guest-quote-support';

export interface GuestQuoteReviewingProps {
  readonly view: Extract<GuestQuoteView, { state: 'REVIEWING' }>;
}

/**
 * 검토 중(결정 G9) — 요청 요약과 회신 기한("영업일 기준 1일 이내") 안내. 견적이 발행되면 같은 링크에 견적서가 보이고 주문 링크가 된다.
 * 그래서 링크 공유 안내를 미리 보여 준다.
 */
export const GuestQuoteReviewing = ({ view }: GuestQuoteReviewingProps): ReactElement => (
  <div className="flex flex-col gap-12">
    <header className="flex flex-col gap-4 border-b border-foreground/10 pb-8">
      <EyebrowLabel accent>Quote</EyebrowLabel>
      <h1 className="text-[clamp(2rem,4vw,3.25rem)] leading-tight font-bold tracking-[-0.03em]">
        견적을 검토하고 있어요
      </h1>
      <p className="max-w-2xl text-[15px] leading-relaxed text-muted-foreground">
        영업일 기준 1일 이내에 남겨 주신 연락처로 연락드릴게요. 견적이 나오면 이 링크에서 견적서를
        확인하고 주문할 수 있어요.
      </p>
      <GuestQuoteLinkNotice className="max-w-2xl" />
    </header>

    <div className="grid gap-12 lg:grid-cols-[minmax(0,1fr)_minmax(0,1fr)] xl:gap-16">
      <DesignThumbnail
        url={view.thumbnailUrl ?? view.productImageUrl}
        alt={quoteImageAlt(view, view.productName, `${view.productName} 디자인 미리보기`)}
      />
      <GuestQuoteSummary summary={view} />
    </div>

    <GuestQuoteSupport />
  </div>
);
